const normalizeKey = (value) => String(value ?? '').trim()

export const filterSimulationToVisibleProducts = (simulationData, visibleProducts = []) => {
	if (!simulationData) return simulationData

	const visibleIds = new Set()
	const visibleCodes = new Set()
	for (const product of visibleProducts || []) {
		const id = normalizeKey(product?.id_producto ?? product?.idProducto ?? product?.product?.id_producto)
		const code = normalizeKey(
			product?.customer_product_code ??
			product?.product?.customer_product_code ??
			product?.product?.original_product_code ??
			product?.codigo_producto ??
			product?.codigoProducto
		)
		if (id) visibleIds.add(id)
		if (code) visibleCodes.add(code)
	}

	return {
		...simulationData,
		resultado_simulacion: (simulationData.resultado_simulacion || []).filter((row) => {
			const id = normalizeKey(row?.id_producto)
			const code = normalizeKey(row?.codigo_producto)
			return (id && visibleIds.has(id)) || (code && visibleCodes.has(code))
		}),
	}
}
